import { getRailsClient } from "sj-ui-toolkit/src/client";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface Level {
  id: string | number;
  name: string;
  rankName: string;
}

export interface LevelsResponse {
  courses: Level[];
}

// ---------------------------------------------------------------------------
// API functions
// ---------------------------------------------------------------------------

export const loadLevelsAsync = async (): Promise<LevelsResponse> => {
  const API = `/api/internal_api/v1/admin/levels`;
  const { data } = await getRailsClient().get<LevelsResponse>(API);
  return data;
};

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

export const isActivityLevel = (level: { rankName?: string }): boolean => {
  return level.rankName === "brown" || level.rankName === "black";
};

export const levelsWithoutSkipped = (levels: Level[]): Level[] => {
  return levels.filter(level => level.name !== "Security Awareness");
};

export const getLevelNameFromRankName = (rankName?: string | null): string | null => {
  const rankToName: Record<string, string> = {
    white: "Foundational",
    yellow: "Intermediate",
    green: "Advanced",
    brown: "Professional",
    black: "Expert",
  };
  return rankName ? (rankToName[rankName] ?? null) : null;
};
